export default "__VITE_ASSET__B25nTSw4__"